"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileBar = void 0;
/* eslint-disable react/jsx-no-bind */
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const core_2 = require("@material-ui/core");
const styles_1 = require("@material-ui/core/styles");
const Menu_1 = __importDefault(require("@material-ui/icons/Menu"));
const HighlightOff_1 = __importDefault(require("@material-ui/icons/HighlightOff"));
const Search_1 = __importDefault(require("@material-ui/icons/Search"));
const useSearchBar_1 = require("../../../hooks/useSearchBar");
const ArrowBack_1 = __importDefault(require("@material-ui/icons/ArrowBack"));
const SimpleGrid_1 = require("../../SimpleGrid");
const hooks_1 = require("../../../hooks");
// eslint-disable-next-line @rushstack/typedef-var
const useStyles = styles_1.makeStyles((theme) => styles_1.createStyles({
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        boxShadow: theme.shadows[0],
        borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
        userSelect: 'none'
    },
    toolbar: {
        paddingLeft: 0,
        paddingRight: 0
    },
    inputRoot: {
        borderColor: 'transparent !important'
    }
}));
const MobileBar = (props) => {
    const classes = useStyles();
    const menuLeft = hooks_1.useComponentVisibility('menuLeft');
    const { appIsLoading = false, userAvatar, searchBarActiveQuery, searchBarDisabled, searchBarPlaceholder = 'Search everything', onSearch, setMenuUserVisible } = props;
    const { handleBlur, handleChange, handleEnterPress, handleFocus, handleResetClick, handleSubmitClick, value, isFocused, disabled } = useSearchBar_1.useSearchBar({
        onSearch,
        disabled: searchBarDisabled,
        activeQuery: searchBarActiveQuery
    });
    return (react_1.default.createElement(core_1.AppBar, { position: "fixed", color: "inherit", elevation: 1, className: classes.appBar },
        react_1.default.createElement(core_1.Toolbar, { classes: { root: onSearch && classes.toolbar } },
            onSearch && (react_1.default.createElement(core_2.TextField, { disabled: disabled, fullWidth: true, placeholder: searchBarPlaceholder, variant: "outlined", onFocus: handleFocus, onBlur: handleBlur, onChange: handleChange, onKeyPress: handleEnterPress, focused: isFocused, value: value, InputProps: {
                    classes: {
                        notchedOutline: classes.inputRoot
                    },
                    startAdornment: (react_1.default.createElement(core_2.InputAdornment, { position: "start" }, isFocused ? (react_1.default.createElement(core_2.IconButton, { onClick: handleResetClick },
                        react_1.default.createElement(ArrowBack_1.default, null))) : (react_1.default.createElement(core_2.IconButton, { onClick: menuLeft.setVisible },
                        react_1.default.createElement(Menu_1.default, null))))),
                    endAdornment: (react_1.default.createElement(core_2.InputAdornment, { position: "end" },
                        isFocused && (react_1.default.createElement(core_2.IconButton, { disabled: disabled, onClick: handleSubmitClick },
                            react_1.default.createElement(Search_1.default, null))),
                        !isFocused && (react_1.default.createElement(react_1.default.Fragment, null,
                            searchBarActiveQuery && (react_1.default.createElement(core_2.IconButton, { onClick: handleResetClick, "aria-label": "delete" },
                                react_1.default.createElement(HighlightOff_1.default, null))),
                            react_1.default.createElement(core_2.IconButton, { onClick: setMenuUserVisible },
                                react_1.default.createElement(core_1.Avatar, { src: userAvatar }))))))
                } })),
            !onSearch && (react_1.default.createElement(SimpleGrid_1.SimpleGrid, { left: react_1.default.createElement(core_2.IconButton, { onClick: menuLeft.setVisible },
                    react_1.default.createElement(Menu_1.default, null)), right: react_1.default.createElement(core_2.IconButton, { onClick: setMenuUserVisible },
                    react_1.default.createElement(core_1.Avatar, { src: userAvatar })) }))),
        appIsLoading && react_1.default.createElement(core_1.LinearProgress, null)));
};
exports.MobileBar = MobileBar;
//# sourceMappingURL=MobileBar.js.map